import { useEffect } from 'react';
import JavascriptBridge from '@/utils/JavascriptBridge';

export default function useKeyboardShortcuts() {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        JavascriptBridge.getInstance().minimizeChat('escape key pressed');
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);
}